import React from 'react';
import OfferList from './List/List';
import './Offer.css';

import previewImage from '../assets/img/offers/1.jpg';

class Offer extends React.Component {
  offerList = [
    {title: "Pierwsza wizyta", img: previewImage},
    {title: "Pedicure pielęgnacyjny", img: previewImage},
    {title: "Pedicure podologiczny", img: previewImage},
    {title: "Stopa cukrzycowa", img: previewImage},
    {title: "Obcinanie paznokci", img: previewImage},
    {title: "Usuwanie odcisków", img: previewImage},
    {title: "Usuwanie modzeli", img: previewImage},
    {title: "Terapia pękających pięt/rozpadlin", img: previewImage},
    {title: "Terapia nadpotliwości stóp", img: previewImage},
    {title: "Terapia nadmiernej suchości stóp", img: previewImage},
    {title: "Terapia wrastających/wkręcających paznokci", img: previewImage},
    {title: "Terapia grzybicy paznokci metodą PACTMED", img: previewImage},
    {title: "Badania mykologiczne i bakteriologiczne", img: previewImage},
    {title: "Podologiczne wizyty domowe", img: previewImage},
    {title: "Dezynfekcja i sterylizacja", img: previewImage},
  ];

  render() {
    return (
      <section className="offer" id="offer">
        <OfferList></OfferList>
      </section>
    )
  }
}

export default Offer;
